import * as types from '../constants/idpAdminActions';
import {authApi} from "../api/api";

export const authStart = () => ({
  type: types.AUTH_START
});
export const authSuccess = (response) => ({
  type: types.AUTH_SUCCESS,
  response,
});
export const authFail = (errorMsg) => ({
  type: types.AUTH_FAIL,
  errorMsg,
});

export function auth(authToken, enterpriseId, applianceUuid) {
  return dispatch => {
    dispatch(authStart());
    return authApi(authToken, enterpriseId, applianceUuid)
    .then(response => {
      dispatch(authSuccess(response));
    })
    .catch((error) => {
      dispatch(authFail(error.message));
    });
  }
}

export const storeCapabilitiesConst = (mappedCapabilities) => ({
  type: types.STORE_CAPABILITIES,
  mappedCapabilities,
});

export function mapAndStoreCapabilities(capabilities) {
  var capabilitiesList = [];
  capabilities
  .filter(object => object.name === "HybridUI")
  .forEach(object => capabilitiesList = capabilitiesList.concat(
      object.capabilities));
  let mappedCapabilities = Object.assign({},
      ...capabilitiesList.map(object => ({[object.capabilityName]: true})));
  return dispatch => {
    dispatch(storeCapabilitiesConst(mappedCapabilities));
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js